module.exports = __webpack_public_path__ + "static/media/kusgautam.f933026f.jpg";